// Module
var code = `<form name="\$ctrl.form">
  <table class="table">
    <tbody>
    <tr>
      <td>File</td>
      <td>
        <file-id-upload
          single-file="true"
          ng-model="\$ctrl.fileId"
          validate-uploaded
          required
          show-remarks="false"
          name="loanTransactionTypeList"
          enable-webcam="false"
          max-files="1"
        ></file-id-upload>
      </td>
      <td></td>
    </tr>
    </tbody>
  </table>

  <div class="flex-end">
    <button
      type="button"
      class=" btn btn-info"
      ng-click="\$ctrl.downloadSampleFile()">
      Download example
    </button>

    <button
      type="button"
      class=" btn btn-success"
      ng-disabled="\$ctrl.form.\$invalid"
      ng-click="\$ctrl.execute()">
      Execute
    </button>
  </div>
</form>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/update-loan-transaction-type/update-loan-transaction-type.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;